import React from 'react';

function HeroSection({ onConsultClick, sampleShopUrl }) {
  return (
    <header className="relative w-full min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: 'linear-gradient(rgba(17, 33, 22, 0.4) 0%, rgba(17, 33, 22, 0.7) 100%), url("https://lh3.googleusercontent.com/aida-public/AB6AXuDNUT5C756Fv83VLBXyxQebkedA48zQ0TxOnA-GeTQyAFADpO-hi--068yp524h8GelAVtfLZZAputJ0NfrRRAVVfFtk3oSFj3mIkHpqralNprLEop8fPL8qEPqwZjYbIZV0yP6K04Xu1kcj5SJCOBmoPLmyhvqYcej7Nv7XOn1Vv-lUWnPMWiPsRRMR02l7QB9jNmBVc9yhTxwvF1OPS0BVAhZeAC5jToxF9ELchVnc_TR-q0aNvSwkRG8dVkpalrHUd6W6Hl2mUi-")'
        }}
      >
      </div>
      <div className="relative z-10 container mx-auto px-4 md:px-10 flex flex-col items-center text-center gap-8 max-w-4xl">
        <div className="flex flex-col gap-4">
          <span className="text-primary font-bold tracking-wider uppercase text-sm md:text-base">Premium Franchise</span>
          <h1 className="text-white text-4xl md:text-6xl font-black leading-tight tracking-tight">
            꽃 배달의 새로운 기준<br/>
            <span className="text-primary">프리미엄</span>을 경험하세요
          </h1>
          <p className="text-gray-200 text-base md:text-xl font-medium max-w-2xl mx-auto leading-relaxed">
            재고 부담 없는 1인 창업부터 데이터 기반의 확실한 수익 모델까지.<br className="hidden md:block"/>
            화환 쇼핑몰 프랜차이즈의 혁신적인 파트너가 되어보세요.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <button
            onClick={onConsultClick}
            className="h-12 px-8 rounded-lg bg-primary text-[#0e1b12] font-bold text-base hover:bg-white hover:text-primary transition-all duration-300 shadow-lg shadow-primary/20"
          >
            지금 시작하기
          </button>
          <a
            href={sampleShopUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="h-12 px-8 rounded-lg border border-white/30 bg-white/10 backdrop-blur-sm text-white font-bold text-base hover:bg-white/20 transition-all duration-300 flex items-center justify-center"
          >
            샘플쇼핑몰 보기
          </a>
        </div>
      </div>
    </header>
  );
}

export default HeroSection;
